import { faUsers } from '@fortawesome/pro-regular-svg-icons';
import { FileKindEnum } from 'scribe-web-shared/enums/file-kind-enums';
import { OptionType, TimeframeEnum } from 'v2/types';

export enum FilterTypesEnum {
  Timeframe = 'Timeframe',
  FileType = 'Document Type'
}

export const timeframeFilterDropdownItems: OptionType[] = [
  {
    label: 'Last 7 Days',
    value: TimeframeEnum.Last7Days
  },
  {
    label: 'Last Month',
    value: TimeframeEnum.Last30Days
  },
  {
    label: 'Last 3 Months',
    value: TimeframeEnum.Last90ays
  },
  {
    label: 'Last Year',
    value: TimeframeEnum.Last365Days
  }
];

export const documentFilterDropdownItems: OptionType[] = [
  {
    label: 'All Documents',
    value: undefined
  },
  {
    label: 'Scribes',
    value: FileKindEnum.Scribe
  },
  {
    label: 'Pages',
    value: FileKindEnum.KnowledgePage
  }
];

export const getTeamFilterDefaultOption = (isSystemAdmin: boolean) => ({
  label: isSystemAdmin ? 'All Teams' : 'All My Teams',
  value: 'teams',
  menuItemProps: {
    icon: faUsers
  }
});
